export const myActionType = "[action type]";



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/iva-availability/src/actions/actionTypes.js